import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpenseReportsRoutingModule } from './expense-reports-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ReportsReceptionComponent } from './components/reports-reception/reports-reception.component';
import { ReportsPaymentComponent } from './components/reports-payment/reports-payment.component';
import { ReportsFeedbackComponent } from './components/reports-feedback/reports-feedback.component';
import { AddEditConceptResponseComponent } from './components/report-review/add-edit-concept-response/add-edit-concept-response.component';
import { ReportsReviewComponent } from './components/reports-review/reports-review.component';
import { ReportReviewComponent } from './components/report-review/report-review.component';
import { ComissionsModule } from '../comissions/comissions.module';
import { ListConceptsComponent } from './components/report-review/list-concepts/list-concepts.component';
import { ReportTotalizerComponent } from './components/report-review/report-totalizer/report-totalizer.component';
import { ViewConceptsComponent } from './components/report-review/view-concepts-layout/view-concepts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { UserRoutingModule } from '../user/user-routing.module';
import { CreateReportComponent } from './components/create-report/create-report.component';
import { DistrictDataComponent } from './components/district-data/district-data.component';
import { ReportTutorialComponent } from './components/report-tutorial/report-tutorial.component';
import { EmployeeDiscountsModule } from '../employee-discounts/employee-discounts.module';
import { ReportHistoryComponent } from './components/report-review/report-history/report-history.component';
import { ReportReviewWCommentComponent } from './components/report-review/report-review-w-comment/report-review-w-comment.component';
import { ListReportsPaymentsComponent } from './components/reports-payment/list-reports-payments/list-reports-payments.component';
import { GenerateLayoutPaymentsComponent } from './components/reports-payment/generate-layout-payments/generate-layout-payments.component';

@NgModule({
  declarations: [
       ReportsReceptionComponent,
       ReportsReviewComponent,
       ReportsPaymentComponent,
       ReportsFeedbackComponent,
       AddEditConceptResponseComponent,
       ReportsReviewComponent,
       ReportReviewComponent,
       ListConceptsComponent,
       ReportTotalizerComponent,
       ViewConceptsComponent,
       CreateReportComponent,
       DistrictDataComponent,
       ReportTutorialComponent,
       ReportHistoryComponent,
       ReportReviewWCommentComponent,
       ListReportsPaymentsComponent,
       GenerateLayoutPaymentsComponent
  ],
  imports: [
    CommonModule,
    ExpenseReportsRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    ComissionsModule,
    NgxPaginationModule,
    UserRoutingModule,
    FormsModule,
    EmployeeDiscountsModule
  ]
})
export class ExpenseReportsModule { }
